import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/elastic-checkin-history";

export const searchCheckInHistory = (searchObject) =>
    axios.post(API_PATH + "/search", searchObject);
